/* eslint-disable react-hooks/exhaustive-deps */

import { Menu, MenuItem, NavBar, Text, Toggle, Tooltip } from '@sede-enterprise/shell-ds-react-framework'
import { AppEnabledSolid, BarChart, Bell, FilePdfOutline, Home, LineChart, PlayCircle, QuestionMarkCircle, RigOffshore } from '@sede-enterprise/shell-ds-react-framework/build/esm/components/Icon/components'
import React, { useContext, useEffect, useState } from 'react'
import { useHistory, useLocation } from 'react-router-dom/cjs/react-router-dom';
import './LeftNav.css';
import { UnitContext } from '../../App';
import { AuthContext } from '../../AuthProvider';
import { CARMA_USER_ROLES, CANCUI_USER_ROLES, INT_USER_ROLES } from '../../util/constants';


const LeftNav = ({ isExpanded, setIsExpanded }) => {


    const authContext = useContext(AuthContext);
    const { role } = authContext;
    const isCarmaUser = CARMA_USER_ROLES.includes(role) || false; // Check if user is CARMA User
    const isCancuiUser = CANCUI_USER_ROLES.includes(role) || false; // Check if user is CANCUI User
    const isIntUser = INT_USER_ROLES.includes(role) || false; // Check if user is Internal User

    const { pathname } = useLocation();
    const getKeyFromPath = (path) => {
        const map = {
            '': 'home',
            'home': 'home',
            'cmls': 'home',
            'cls': 'home',
            'alerts': 'alerts',
            'alertsReport': 'alerts',
            'analysis': 'analysis',
            'statistics': 'statistics',
            'cancui': 'cancui',
            'models': 'models',
            'modelDetails': 'model'
        };
        const firstPartOfPath = path.split('/')[1];
        return map[firstPartOfPath];
    };

    const link = "https://eu001-sp.shell.com/sites/SPO000334/Shared%20Documents/Forms/AllItems.aspx?id=%2Fsites%2FSPO000334%2FShared%20Documents%2FAbout%20MRTA%2FApps%20%26%20Products%2FCARMA%2F24%2E0%20User%20Manual%2FCARMA%20%2D%20Tool%20Guide%2Epdf&parent=%2Fsites%2FSPO000334%2FShared%20Documents%2FAbout%20MRTA%2FApps%20%26%20Products%2FCARMA%2F24%2E0%20User%20Manual&p=true&ga=1"
    const history = useHistory()
    const unitContext = useContext(UnitContext);

    // useEffect(() => {
    //     c3request("CarmaConfig", "configValue", { path: "UserManual" }).then((res) => {
    //         setLink(res.value);
    //     });
    // }, []);

    const handleSwitch = () => {
        unitContext.units === false
            ? unitContext.toggleUnits(true)
            : unitContext.toggleUnits(false);
    };

    //Getting access of SDS NavBar expand toggle button
    useEffect(() => {
        const expandToggle = document.querySelector('[aria-roledescription="Expand navigation bar"]')
        if (expandToggle) {
            expandToggle.addEventListener("click", () => {
                setIsExpanded((prev) => !prev)
            })
        }
    }, [])

    useEffect(() => {
        //check if current path is "/" or "/home"
        if ((pathname === "/" || pathname === "/home") && role === 'CANCUI_User') {
            history.push('/cancui')
        }
    }, [isCancuiUser]);

    return (
        <NavBar direction='vertical'
            collapsed
            expandedWidth={125}
            data-testid='left-nav'
            id='left-nav-id-1'
            avatarArea={<div className='unit-toggle' id='left-nav-id-2'>
                {
                    isExpanded ?
                        <>
                            <Toggle data-testid="unit-toggle-button" size='small' checked={unitContext.units} onChange={handleSwitch} id="left-nav-id-4" />
                            <Text className='toggle-text' id="left-nav-id-5">Imperial Units</Text>
                        </>
                        :
                        <Tooltip id="left-nav-id-3" placement='right' overlay={<Text size='small' id="left-nav-id-4">Imperial Units</Text>}
                            trigger={<Toggle data-testid="unit-toggle-button" size='small' checked={unitContext.units} onChange={handleSwitch} id="left-nav-id-5" />} />
                }
            </div>}
        >
            <Menu mode='vertical' className='left-menu' selectedKeys={[getKeyFromPath(pathname)]} id="left-nav-id-6">
                {(isIntUser || isCarmaUser) && <>
                    <MenuItem data-testid='home-link' key="home" itemIcon={<Home />} onClick={() => history.push('/')} id="left-nav-id-7">Home</MenuItem>
                <MenuItem data-testid='alerts-link' key="alerts" itemIcon={<Bell />} onClick={() => history.push('/alerts')} id="left-nav-id-8">Alerts</MenuItem>
                <MenuItem data-testid='analysis-link' key="analysis" itemIcon={<BarChart />} onClick={() => history.push('/analysis')} id="left-nav-id-9">Analysis</MenuItem>

                <MenuItem data-testid='model-link' key="models" itemIcon={<PlayCircle />} onClick={() => history.push('/models')} id="left-nav-id-12">CAM</MenuItem>
                </>}
                {(isIntUser || isCancuiUser) && <MenuItem data-testid='cancui-link' key="cancui" itemIcon={<AppEnabledSolid />} onClick={() => history.push('/cancui')} id="left-nav-id-12">CAN-CUI</MenuItem>}

                {isIntUser && <MenuItem data-testid='statistics-link' key="statistics" itemIcon={<LineChart />} onClick={() => history.push('/statistics')} id="left-nav-id-10">Statistics</MenuItem>}

                {(isIntUser || isCarmaUser) && <MenuItem key="manual" itemIcon={<FilePdfOutline />}
                    onClick={() => window.open(link, '_blank')}
                    id="left-nav-id-11">
                    Manual
                </MenuItem>}
                <MenuItem key="help" itemIcon={<QuestionMarkCircle />}
                    onClick={() => window.open('https://eu001-sp.shell.com/:u:/r/sites/AAFAA7531/SitePages/CARMA---Corrosion-Advanced-Risk-Modelling-%26-Analytics.aspx', '_blank')}
                    id="left-nav-id-12">
                    Help
                </MenuItem>
            </Menu>
        </NavBar >
    )
}

export default LeftNav